/* Belfa FX — display-only ≈ $/€ conversion next to TRY prices on non-TR locales.
   Fills every `.belfa-fx[data-try-cents]` span (emitted by snippets/belfa-fx.liquid).
   Rates: ECB via frankfurter.dev, cached in localStorage for 24h; falls back to the
   manual rates set in theme settings; on total failure the spans stay empty (hidden
   by the `.belfa-fx:empty` rule). Checkout is always billed in TRY. */
(function () {
  'use strict';

  var CFG = document.currentScript ? document.currentScript.dataset : {};
  var KEY = 'belfa_fx_v1';
  var TTL = 24 * 60 * 60 * 1000;
  var API = 'https://api.frankfurter.dev/v1/latest?base=TRY&symbols=USD,EUR';
  var rates = null;

  function fallbackRates() {
    // Theme settings hold "1 USD/EUR = X TRY"; invert to TRY→USD/EUR.
    var usd = parseFloat(CFG.usdFallback);
    var eur = parseFloat(CFG.eurFallback);
    var r = {};
    if (usd > 0) r.usd = 1 / usd;
    if (eur > 0) r.eur = 1 / eur;
    return r.usd || r.eur ? r : null;
  }

  function cachedRates() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY));
      if (d && d.ts && Date.now() - d.ts < TTL && d.usd && d.eur) return d;
    } catch (e) {
      /* ignore */
    }
    return null;
  }

  function storeRates(r) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), usd: r.usd, eur: r.eur }));
    } catch (e) {
      /* ignore */
    }
  }

  function fmt(n) {
    if (!isFinite(n)) return '';
    return n >= 10 ? Math.round(n).toLocaleString('en-US') : n.toFixed(1);
  }

  function render() {
    if (!rates) return;
    var nodes = document.querySelectorAll('.belfa-fx[data-try-cents]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cents = parseFloat(el.getAttribute('data-try-cents'));
      if (!isFinite(cents)) continue;
      var t = cents / 100;
      var parts = [];
      if (rates.usd) parts.push('$' + fmt(t * rates.usd));
      if (rates.eur) parts.push('€' + fmt(t * rates.eur));
      var text = parts.length ? '≈ ' + parts.join(' / ') : '';
      if (el.textContent !== text) el.textContent = text;
    }
  }

  function start() {
    var cached = cachedRates();
    if (cached) {
      rates = cached;
      render();
    } else {
      fetch(API)
        .then(function (r) {
          return r.ok ? r.json() : Promise.reject(new Error('fx http ' + r.status));
        })
        .then(function (d) {
          if (d && d.rates && d.rates.USD && d.rates.EUR) {
            rates = { usd: d.rates.USD, eur: d.rates.EUR };
            storeRates(rates);
          } else {
            rates = fallbackRates();
          }
          render();
        })
        .catch(function () {
          rates = fallbackRates();
          render();
        });
    }

    // Cart drawer / cart page / PDP price blocks re-render via section rendering;
    // re-scan (debounced) so fresh spans get filled and updated cents re-format.
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        render();
      }, 60);
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-try-cents'],
    });
  }

  window.BelfaFX = { refresh: render };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
